export enum ChainIds {
  Ethereum = 1,
  Bsc = 56,
  Arb = 42161,
  Pol = 137,
  Pul = 369,
  Bit = 7171,
  Shi = 109,
  Cyb = 6661,
  Sol = 501424,
  Base = 8453,
  Rbh = 4663,
  Xla = 196,
  Sta = 988,
  Ecl = 3254774,
  Sui = 50104,
  Ton = -239,
  // Avalanche = 43114,
  // FantomOpera = 250,
}

export enum ChainNames {
  Bsc = "bsc",
  Ethereum = "eth",
  Arbitrum = "arbitrum",
  Polygon = "polygon",
  Pulse = "pulse",
  Bitrock = "bitrock",
  Shibariym = "shibarium",
  Cybria = "cybria",
  Solana = "solana",
  Base = "base",
  Robinhood = "robinhood",
  XLayer = "xlayer",
  Stable = "stable",
  Eclipse = "eclipse",
  Sui = "sui",
  Ton = "ton",
  // Avalanche = 'avalanche',
  // FantomOpera = 'fantom',
}

export const listChains = [
  { name: ChainNames.Bsc, value: ChainIds.Bsc },
  { name: ChainNames.Ethereum, value: ChainIds.Ethereum },
  { name: ChainNames.Arbitrum, value: ChainIds.Arb },
  { name: ChainNames.Polygon, value: ChainIds.Pol },
  { name: ChainNames.Pulse, value: ChainIds.Pul },
  { name: ChainNames.Bitrock, value: ChainIds.Bit },
  { name: ChainNames.Shibariym, value: ChainIds.Shi },
  { name: ChainNames.Cybria, value: ChainIds.Cyb },
  { name: ChainNames.Solana, value: ChainIds.Sol },
  { name: ChainNames.Base, value: ChainIds.Base },
  { name: ChainNames.Robinhood, value: ChainIds.Rbh },
  { name: ChainNames.XLayer, value: ChainIds.Xla },
  { name: ChainNames.Stable, value: ChainIds.Sta },
  { name: ChainNames.Eclipse, value: ChainIds.Ecl },
  { name: ChainNames.Sui, value: ChainIds.Sui },
  { name: ChainNames.Ton, value: ChainIds.Ton },
  // { name: ChainNames.Avalanche, value: ChainIds.Avalanche },
  // { name: ChainNames.BscTest, value: ChainIds.BscTest },
  // { name: ChainNames.FantomOpera, value: ChainIds.FantomOpera },
];

export const getChainNameFromChainId = (chainId: ChainIds) =>
  listChains.find((chain) => chain.value === chainId)?.name;
